const POSITIVE_FLOAT_REGEX = /\d{1,12}(\.\d{0,2})?/ // 1-12 integer part length and 0-2 decimal part

// eslint-disable-next-line import/prefer-default-export
export const parseFloatFromString = (str: string) => {
  const numberMatches = str.match(POSITIVE_FLOAT_REGEX)

  return numberMatches ? numberMatches[0] : ''
}
